import { defaultOptions, prevArrow, nextArrow } from "../utilities/slider";

const timelineSliders = document.querySelectorAll('[data-slider="timeline-slider"]');
console.log('test');

if (timelineSliders.length) {
    timelineSliders.forEach((slider) => {
        jQuery(slider).slick({
            ...defaultOptions,
            autoplay: false,
            infinite: false,
            slidesToShow: 4.25,
            slidesToScroll: 1,
            nextArrow,
            prevArrow,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3.25,
                    },
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 1.25,
                    },
                },
            ],
        });
    });
}
